export type QuickNavKind = "page" | "class" | "action" | "skill" | "item";

export interface IQuickNavEntry {
    label: string;
    keywords: string;
    icon: string;
    kind: QuickNavKind;
    route: object | string;
    // sprite-sheet icon (class/skill entries); takes precedence over `icon`
    spriteIcon?: object | null;
    // game item icon (item entries); takes precedence over `icon`
    itemIcon?: { iconIndex: number; rank: string } | null;
    // renders indented under its group's action row
    child?: boolean;
}

const SCORE_EMPTY = 1;
const SCORE_PREFIX = 100;
const SCORE_WORD_START = 80;
const SCORE_SUBSTRING = 60;
const SCORE_SUBSEQUENCE = 20;

export function scoreEntry(query: string, entry: IQuickNavEntry): number {
    const q = query.trim().toLowerCase();
    if (!q) {
        return SCORE_EMPTY;
    }

    const hay = (entry.label + " " + entry.keywords).toLowerCase();

    if (hay.startsWith(q)) {
        return SCORE_PREFIX;
    }

    if (hay.split(/\s+/).some((w) => w.startsWith(q))) {
        return SCORE_WORD_START;
    }

    if (hay.indexOf(q) !== -1) {
        return SCORE_SUBSTRING;
    }

    let i = 0;
    for (const c of hay) {
        if (c === q[i]) {
            i++;
            if (i === q.length) {
                return SCORE_SUBSEQUENCE;
            }
        }
    }

    return 0;
}

export function filterEntries(
    query: string,
    entries: IQuickNavEntry[],
    limit: number = 8,
): IQuickNavEntry[] {
    return entries
        .map((e) => ({ e, s: scoreEntry(query, e) }))
        .filter((x) => x.s > 0)
        .sort((a, b) => b.s - a.s)
        .map((x) => x.e)
        .slice(0, limit);
}
